var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 3.1875V0H0.5625C0.234375 0 0 0.257812 0 0.5625V11.4375C0 11.7656 0.234375 12 0.5625 12H8.4375C8.74219 12 9 11.7656 9 11.4375V3.75H5.8125C5.48438 3.75 5.25 3.51562 5.25 3.1875ZM6.65625 5.69531L5.25 7.875L6.65625 10.0781C6.77344 10.2656 6.63281 10.5 6.42188 10.5H5.60156C5.48438 10.5 5.39062 10.4531 5.34375 10.3594C4.875 9.51562 4.5 8.74219 4.5 8.74219C4.33594 9.09375 4.26562 9.21094 3.63281 10.3594C3.58594 10.4531 3.49219 10.5234 3.375 10.5234H2.57812C2.34375 10.5234 2.20312 10.2656 2.32031 10.0781L3.75 7.89844L2.32031 5.69531C2.20312 5.50781 2.34375 5.27344 2.57812 5.27344H3.375C3.49219 5.27344 3.58594 5.32031 3.63281 5.41406C4.24219 6.5625 4.10156 6.1875 4.5 7.00781C4.5 7.00781 4.64062 6.75 5.34375 5.41406C5.39062 5.32031 5.48438 5.27344 5.60156 5.27344H6.42188C6.63281 5.25 6.77344 5.50781 6.65625 5.69531ZM9 2.85938C9 2.71875 8.92969 2.57812 8.83594 2.46094L6.53906 0.164062C6.42188 0.0703125 6.28125 0 6.14062 0H6V3H9V2.85938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelFile);
export default __webpack_public_path__ + "static/media/excel-file.60f3bf767176f461285fd1af6a4857a7.svg";
export { ForwardRef as ReactComponent };